import {
  RatingType,
  TourAvailabilityHotel,
  TourAvailabilityList,
  TourAvailabilityMonths,
  TourAvailabilityResult,
  TourContent,
  TourDetailResponse,
  TourHotel,
  TourResponse,
  ToursPackagesResponse
} from '@model/tours';
import { TripTypes } from '@model/common';
import { DepartingType, Itinerary } from '@model/iceberg/common';
import { TourHit, TourType } from '@model/search';
import { TourSearchState } from '@model/state/search-forms-state';
import { TourExtra } from '@model/iceberg/booking/basket/extras';
import { ExtrasOptions } from '@model/iceberg/booking/extras/extras-options';
import { INITIAL_TOUR_SEARCH_STATE } from '@state/search/tours/tourSearchOperations';

export const MOCK_TOUR_DETAILS: TourResponse<TourDetailResponse> = {
  data: {
    tours: [
      {
        name: 'Malta and Gozo',
        days: 16,
        price: { amount: 179900, currency: { code: 'GBP', symbol: '£' } },
        tripType: TripTypes.ESCORTED_TOURS,
        path: 'europe/malta-and-gozo/malta-and-gozo',
        subTitle: '',
        image:
          'http://3.bp.blogspot.com/-u2NqDzbNqrs/UU56-FL7tLI/AAAAAAAAAYo/F0S0HsjqFHo/s1600/terracotta-army-warriors-china-2.jpg',
        excursionsCount: 5,
        mealsCount: 25,
        pace: 3
      },
      {
        name: 'Historical Malta',
        days: 10,
        price: { amount: 102900, currency: { code: 'GBP', symbol: '£' } },
        tripType: TripTypes.ESCORTED_TOURS,
        path: 'europe/malta-and-gozo/historical-malta',
        subTitle: '',
        image:
          'https://www.telegraph.co.uk/content/dam/Travel/Destinations/Asia/China/china-touroperators-beaut-xlarge.jpg',
        excursionsCount: 5,
        mealsCount: 25,
        pace: 3
      },
      {
        name: 'Dummy Tour in Malta',
        days: 12,
        price: { amount: 189900, currency: { code: 'GBP', symbol: '£' } },
        tripType: TripTypes.ESCORTED_TOURS,
        path: 'europe/malta-and-gozo/malta-and-gozo-with-malta-city-stay',
        subTitle: '',
        image: 'https://exclusivesmedia.webjet.com.au/uploads/2017/10/Essentials-China-2-min.jpg',
        excursionsCount: 5,
        mealsCount: 25,
        pace: 3
      }
    ]
  }
};

export const MOCK_TOUR_CONTENT: TourResponse<TourContent> = {
  data: {
    connectId: 'PT394',
    name: 'Dummy Tour in Malta',
    days: 16,
    allMealsIncluded: true,
    pace: 2,
    mealsCount: 10,
    excursionsCount: 5,
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    price: { amount: 129900, currency: { code: 'GBP', symbol: '£' } },
    type: TripTypes.ESCORTED_TOURS,
    imageUrl: 'https://images.mercuryholidays.co.uk/tour-details/124/Vietnam_and_Cambodia_Odyssey.jpg',
    subTitle: '16 Day Escorted Tour',
    path: 'south-east-asia/vietnam/vietnam-and-cambodia-odyssey',
    place: {
      continent: {
        path: 'south-east-asia',
        display: 'South East Asia'
      },
      country: {
        name: {
          path: 'south-east-asia/vietnam',
          display: 'Vietnam'
        },
        isoCode: 'VN'
      },
      region: {
        path: '',
        display: ''
      },
      resort: {
        path: '',
        display: ''
      },
      tour: {
        name: {
          path: 'south-east-asia/vietnam/vietnam-and-cambodia-odyssey',
          display: 'Vietnam and Cambodia Odyssey'
        }
      }
    },
    dossiers: [
      {
        url: '/dossier-2020',
        name: '2020 Dossier'
      },
      {
        url: '/dossier-2021',
        name: '2021 Dossier'
      }
    ],
    gallery: [
      {
        title: 'The fantastic Malta',
        url: 'https://cdn-image.travelandleisure.com/sites/default/files/1435348005/WBISLANDS0715-malta.jpg'
      }
    ],
    highlights: ['Great tour', 'Go wild', 'Drink responsibly', 'Take a pillow with you'],
    extensions: [
      {
        name: 'Gozo',
        days: 2,
        price: { amount: 49900, currency: { code: 'GBP', symbol: '£' } },
        imageUrl: 'https://www.xlendi.com/wp-content/uploads/2015/12/gozo-malta-luxury-hotels.jpg',
        path: 'europe/malta-and-gozo/malta-and-gozo-with-malta-city-stay'
      },
      {
        name: 'Historical Tour',
        days: 3,
        price: { amount: 59900, currency: { code: 'GBP', symbol: '£' } },
        imageUrl: 'https://pix10.agoda.net/hotelImages/420/420076/420076_13022517300010539954.jpg?s=1024x768',
        path: 'europe/malta-and-gozo/malta/dummy-tour-in-malta'
      }
    ],
    hotels: [
      {
        name: 'Sapporo Excel Hotel Tokyu',
        address: '5 Chome-420 Minami 8 Jonishi, Sapporo, Hokkaido',
        resort: 'Sapporo',
        country: 'Japan',
        rating: 4,
        ratingType: 'STARS',
        telephone: '+81 11-533-0109',
        description:
          'Located in the beautiful area of Sapporo, the Sapporo Excel Hotel Tokyo is the perfect starting place for your tour of Japan. The hotel has its own restaurant which serves Japanese and Western cuisine. Guest Rooms will come equipped with a hairdryer, cable TV as well as a fridge.',
        featuredImage: 'https://images.mercuryholidays.co.uk/tour-hotel/3571/hotel-exterior.jpg',
        gallery: [
          {
            title: 'Hotel Exterior',
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/3571/hotel-exterior.jpg'
          },
          {
            title: 'Double Room',
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/3571/double-room.jpg'
          },
          {
            title: 'Breakfast Dining Options',
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/3571/breakfast-dining-options.jpg'
          }
        ],
        deckPlans: [],
        cabinPlan: {
          title: '',
          url: ''
        },
        cabinPlanCaption: null,
        cabinInformation: null,
        departureDates: [],
        nights: 1
      },
      {
        name: 'Hakodate Kokusai Hotel',
        address: '5-10 Ote-machi, Hakodate-shi,, Hokkaido , 040-0064',
        resort: 'Hakodate ',
        country: 'Japan',
        rating: 3,
        ratingType: 'STARS',
        telephone: '+81-(0)138-23-0591',
        description: null,
        featuredImage: 'https://images.mercuryholidays.co.uk/tour-hotel/10188/exterior.jpg',
        gallery: [
          {
            title: 'Exterior',
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/10188/exterior.jpg'
          }
        ],
        deckPlans: [],
        cabinPlan: {
          title: '',
          url: ''
        },
        cabinPlanCaption: null,
        cabinInformation: null,
        departureDates: [],
        nights: 3
      },
      {
        name: 'Shinjuku Washington Hotel',
        address: '3 Chome-2-9 Nishishinjuku, Shinjuku City, Tokyo 160-0023',
        resort: 'Tokyo',
        country: 'Japan',
        rating: 3,
        ratingType: 'STARS',
        telephone: '+81 3-3343-3111',
        description:
          "the hotel is located in the popular Shinjuku district of Tokyo, which is known for its shopping, dining, and entertainment options. The hotel is within walking distance of many of the area's top attractions, including Shinjuku JR Train Station, the Tokyo Metropolitan Government Buildings, and Shinjuku Gyoen Park. The Kabukicho entertainment area, famous for its nightlife, is also nearby.\r\n\r\nThe hotel's compact rooms come equipped with a refrigerator and hairdryer for guests' convenience. Additionally, guests can enjoy pay-per-view movies on the flat-screen TV. The hotel also features a lounge with massage chairs, and offers concierge service and free WiFi.",
        featuredImage: 'https://images.mercuryholidays.co.uk/tour-hotel/11368/Shinjuku-hotel.jpg',
        gallery: [
          {
            title: null,
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/11368/Shinjuku-hotel.jpg'
          },
          {
            title: null,
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/11368/Shinjuku-twin-room.jpg'
          },
          {
            title: null,
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/11368/Shinjuku-dining.jpg'
          },
          {
            title: null,
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/11368/Shinjuku-reception.jpg'
          }
        ],
        deckPlans: [],
        cabinPlan: {
          title: '',
          url: ''
        },
        cabinPlanCaption: null,
        cabinInformation: null,
        departureDates: [],
        nights: 1
      },
      {
        name: 'Hakone Yutowa',
        address: '1300-27 Gora, Hakone, Ashigarashimo District, Kanagawa 250-0408, Japan',
        resort: 'Hakone',
        country: 'Japan',
        rating: null,
        ratingType: 'STARS',
        telephone: '+81 460-82-0321',
        description:
          'Located in Hakone, just 500 meters from Hakone Gora Park, Hakone Yutowa offers a restaurant, a shared lounge, and a terrace. The property is conveniently situated 600 meters from Hakone Open-Air Museum, with Pola Museum and Venetian Glass Museum just 5 km away. Guests may enjoy the hot spring bath and free WiFi throughout the property, with a 24-hour front desk available for assistance. The guest rooms in “East Building” and “West Building” are hotel-style, totaling 62 rooms. All rooms feature a TV, Wi-Fi,  a safety deposit box, and a hairdryer on request.',
        featuredImage: 'https://images.mercuryholidays.co.uk/tour-hotel/12155/Hakone-Yutowa.jpg',
        gallery: [
          {
            title: null,
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/12155/Hakone-Yutowa.jpg'
          }
        ],
        deckPlans: [],
        cabinPlan: {
          title: '',
          url: ''
        },
        cabinPlanCaption: null,
        cabinInformation: null,
        departureDates: [],
        nights: 2
      },
      {
        name: 'Iroha Grand Hotel Matsumoto',
        address: '1 Chome-14-9 Central, Matsumoto, Nagano 390-0811, Japan',
        resort: 'Matsumoto',
        country: 'Japan',
        rating: null,
        ratingType: 'STARS',
        telephone: '+81 263-87-0168',
        description:
          "Within walking distance, explore national treasures like Matsumoto Castle and Former Kaichi School, as well as the charming storehouse streets of Nakamachi-dori and Nawate-dori. Enjoy easy access to Matsumoto's largest downtown area, just a 1-minute walk away.\r\nThe rooms come with air conditioning, a flat-screen TV with satellite channels, a fridge, a coffee machine, a bidet, toiletries, and a desk. Featuring a private bathroom with a hairdryer. Rooms at the hotel also provide guests with a city view.",
        featuredImage: 'https://images.mercuryholidays.co.uk/tour-hotel/12164/Iroha-Grand-Hotel-Matsumoto.jpg',
        gallery: [
          {
            title: null,
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/12164/Iroha-Grand-Hotel-Matsumoto.jpg'
          }
        ],
        deckPlans: [],
        cabinPlan: {
          title: '',
          url: ''
        },
        cabinPlanCaption: null,
        cabinInformation: null,
        departureDates: [],
        nights: 3
      },
      {
        name: 'Moxy Kyoto Nijo',
        address: '12 Nishinokyo Nanseicho, Nakagyo Ward, Kyoto, 604-8412, Japan',
        resort: 'Kyoto',
        country: 'Japan',
        rating: 4,
        ratingType: 'STARS',
        telephone: '+81 75-801-2200',
        description:
          'Moxy Kyoto features a fitness centre, shared lounge, a terrace and restaurant in Kyoto. The air-conditioned rooms feature a flat-screen TV, a safety deposit box, a kettle, and a private bathroom with a shower, a bidet, and a hairdryer.',
        featuredImage: 'https://images.mercuryholidays.co.uk/tour-hotel/12158/moxy-kyoto.jpg',
        gallery: [
          {
            title: null,
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/12158/moxy-kyoto.jpg'
          }
        ],
        deckPlans: [],
        cabinPlan: {
          title: '',
          url: ''
        },
        cabinPlanCaption: null,
        cabinInformation: null,
        departureDates: [],
        nights: 1
      },
      {
        name: 'RIHGA Royal Hotel Hiroshima',
        address: '6-78 Motomachi, Naka Ward, Hiroshima, 730-0011, Japan',
        resort: 'Hiroshima',
        country: 'Japan',
        rating: 4,
        ratingType: 'STARS',
        telephone: '+81 82-502-1121',
        description:
          'Rihga Royal Hotel is conveniently located just a 10-minute drive from JR Hiroshima Train Station. The hotel is situated within a 5 to 10-minute walk from the Atomic Bomb Dome and Hiroshima Peace Memorial Park. Additionally, the Hiroshima Museum of Art is only a 2-minute walk away, while Hiroshima Castle can be reached in approximately 6 minutes on foot. \r\n\r\nEach air-conditioned room is equipped with a flat-screen satellite TV, a desk. a hairdryer and a private bathroom with amenities. Free WiFi is accessible in all guest rooms.',
        featuredImage: 'https://images.mercuryholidays.co.uk/tour-hotel/12173/rihga-royal-hotel-hiroshima.jpg',
        gallery: [
          {
            title: null,
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/12173/rihga-royal-hotel-hiroshima.jpg'
          }
        ],
        deckPlans: [],
        cabinPlan: {
          title: '',
          url: ''
        },
        cabinPlanCaption: null,
        cabinInformation: null,
        departureDates: [],
        nights: 2
      },
      {
        name: 'Hakata Excel Hotel',
        address: '4 Chome-6-7 Nakasu, Hakata Ward, Fukuoka, 810-0801, Japan',
        resort: 'Fukuoka',
        country: 'Japan',
        rating: 4,
        ratingType: 'STARS',
        telephone: '+81 92-262-0109',
        description:
          'Excel Hotel offers elegantly appointed rooms featuring a 37-inch LCD satellite TV, Tempur-pedic pillows, and private baths, just steps away from Nakasu-Kawabata Train Station. Guests can grab a bite to eat at the on-site restaurant or relax at the tea lounge. Complimentary WiFi is accessible throughout the property.',
        featuredImage: 'https://images.mercuryholidays.co.uk/tour-hotel/12153/hakata-excel.jpg',
        gallery: [
          {
            title: null,
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/12153/hakata-excel.jpg'
          }
        ],
        deckPlans: [],
        cabinPlan: {
          title: '',
          url: ''
        },
        cabinPlanCaption: null,
        cabinInformation: null,
        departureDates: [],
        nights: 3
      },
      {
        name: 'The City View',
        address: 'No.23 Waterloo Road, Kowloon, Hong Kong',
        resort: 'Hong Kong',
        country: 'China',
        rating: 3,
        ratingType: 'STARS',
        telephone: '+852 2783 3888',
        description:
          "The modern Cityview hotel occupies a great position in downtown Kowloon, within walking distance of many of the city's iconic sites including the Temple street night market and Jade market. The rest of Hong Kong and Kowloon can be explored via the nearby MTR station which is only a minutes walk away.",
        featuredImage: 'https://images.mercuryholidays.co.uk/tour-hotel/1077/twin-room.jpg',
        gallery: [
          {
            title: 'Twin Room',
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/1077/twin-room.jpg'
          },
          {
            title: 'Hotel Entrance',
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/1077/hotel-entrance.jpg'
          },
          {
            title: 'Restaurant',
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/1077/restaurant.jpg'
          },
          {
            title: 'Buffet Restaurant',
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/1077/buffet-restaurant.jpg'
          },
          {
            title: 'Bar',
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/1077/bar.jpg'
          }
        ],
        deckPlans: [],
        cabinPlan: {
          title: '',
          url: ''
        },
        cabinPlanCaption: null,
        cabinInformation: null,
        departureDates: [],
        nights: 1
      }
    ],
    vessels: [
      {
        name: 'MS Cyrano De Bergerac',
        address: 'Dordogne River, Bordeaux',
        resort: 'Bordeaux River',
        country: 'France',
        rating: 5,
        ratingType: 'ANCHORS',
        telephone: null,
        description:
          "MS Cyrano de Bergerac is a modern ship with 87 invitingly decorated cabins, accentuated by many vibrant paintings. \r\n\r\nOn this 3-deck, 110 metre-long vessel you can enjoy a drink from the bar whilst relaxing on the vessel's terrace, soak up rays on the sun deck, or simply take in the views from the comfort of your cabin. \r\n\r\nThe ship features a range of facilities for you to enjoy throughout, including a lounge with a dance floor, a bar with a TV and terrace, a restaurant with a casual yet elegant atmosphere, a large sundeck, a terrace, french balconies, and heating/air conditioning.  Please note that there is no laundry service on board the ship.\r\n\r\nPlease refer to the tour dossier for further information including deck and cabin plans.",
        featuredImage: 'https://images.mercuryholidays.co.uk/tour-hotel/11133/ms-cyrano-de-bergerac.jpg',
        gallery: [
          {
            title: 'Ms Cyrano De Bergerac',
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/11133/ms-cyrano-de-bergerac.jpg'
          },
          {
            title: 'Reception',
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/11133/reception.jpg'
          },
          {
            title: 'Outdoor Seating',
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/11133/outdoor-seating.jpg'
          },
          {
            title: 'Bar',
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/11133/bar.jpg'
          },
          {
            title: 'Bar Seating Area',
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/11133/bar-seating-area.jpg'
          },
          {
            title: 'Restaurant',
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/11133/restaurant.jpg'
          },
          {
            title: 'Main Deck',
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/11133/main-deck.jpg'
          },
          {
            title: 'Cabin',
            url: 'https://images.mercuryholidays.co.uk/tour-hotel/11133/cabin.jpg'
          }
        ],
        deckPlans: [],
        cabinPlan: {
          title: '',
          url: 'https://images.mercuryholidays.co.uk/tour-hotel/11133/cyrano-de-bergerac.jpg'
        },
        cabinPlanCaption: null,
        cabinInformation:
          'All cabins are equipped with a shower and toilet, hairdryer, satellite TV, radio, Wi-Fi, telephone (internal calls), and safe. Please note that there is no laundry service on board the ship.',
        nights: 6,
        departureDates: []
      }
    ],
    information: {
      visa: 'foo',
      insurance: 'foo',
      payment: 'foo',
      flight: 'foo',
      health: 'foo',
      accessibility: 'foo',
      groupSize: 'bar',
      tourGuide: 'foo',
      currency: 'bar',
      expenses: 'bar'
    },
    reviews: [
      {
        name: 'John Doe',
        date: '2020-06-15T00:00:00.000Z',
        review:
          'One of the best tours we have ever had. Lovely guides that ensured everything ran smoothly and at the pace we wanted. Stunning hotels, the hotel/ restaurant food very acceptable and all the sightseeing trips left us with many memories.'
      },
      {
        name: 'Jimmy G.',
        date: '2020-06-10T00:00:00.000Z',
        review:
          'One of the best tours we have ever had. Lovely guides that ensured everything ran smoothly and at the pace we wanted. Stunning hotels, the hotel/ restaurant food very acceptable and all the sightseeing trips left us with many memories.'
      },
      {
        name: 'Ben O.',
        date: '2020-06-20T00:00:00.000Z',
        review:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum'
      },
      {
        name: 'Some Dude',
        date: '2020-06-15T00:00:00.000Z',
        review:
          'One of the best tours we have ever had. Lovely guides that ensured everything ran smoothly and at the pace we wanted. Stunning hotels, the hotel/ restaurant food very acceptable and all the sightseeing trips left us with many memories.'
      },
      {
        name: 'Another Dude',
        date: '2020-06-10T00:00:00.000Z',
        review:
          'One of the best tours we have ever had. Lovely guides that ensured everything ran smoothly and at the pace we wanted. Stunning hotels, the hotel/ restaurant food very acceptable and all the sightseeing trips left us with many memories.'
      },
      {
        name: 'One More Dude',
        date: '2020-06-20T00:00:00.000Z',
        review:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum'
      }
    ],
    whatsIncluded: [
      {
        item: 'International Return Flights',
        included: true
      },
      {
        item: 'Hand-picked Accommodation',
        included: true
      },
      {
        item: '9 Meals',
        included: true
      },
      {
        item: 'Overseas Transfers and Transport (as per itinerary)',
        included: true
      },
      {
        item: '7 Excursions',
        included: true
      },
      {
        item: 'Expert Local Tour Guide',
        included: true
      },
      {
        item: 'All entrance fees',
        included: true
      },
      {
        item: 'ABTA & ATOL Protection',
        included: true
      }
    ]
  }
};

export const MOCK_ITINERARY: Array<Itinerary> = [
  {
    place: 'UK to Shanghai',
    text: 'Flight from London Heathrow to China with China Eastern',
    departingType: DepartingType.FLIGHT,
    dayNo: 1,
    length: 1,
    meals: ''
  },
  {
    place: 'Shanghai',
    text: 'On arrival in Shanghai you will be met by your local guide and transferred to your hotel before going out for dinner. Time permitting, after dinner you will experience your first taste of the city with a visit to the magnificent Bund, then a walk along Nanjing Road, the main shopping area in Shanghai.',
    dayNo: 2,
    length: 1,
    meals: 'Breakfast, Lunch & Dinner'
  },
  {
    place: 'Shanghai',
    text: "Following breakfast, you will embark on a full day tour of the city, taking in the delights of the famous classical Yuyuan Garden, the French Concession and Tianzifang, the arts and crafts enclave in the French neighbourhood. After lunch you can saunter around Xintiandi - 'The City's Living Room', a multifunctional entertainment district with unique 1920's style stone gate buildings known as 'shikumen'",
    dayNo: 3,
    length: 1,
    meals: 'Breakfast, Lunch & Dinner'
  },
  {
    place: 'Shanghai to Yangtze River',
    text: 'After breakfast, you will be transferred to the airport for your flight to Wuhan, where you will continue to Yichang to board your ship for the four-night Yangtze River Cruise which will tour the Three Gorges Dam and breath-taking scenery along the way as you cruise upstream …',
    dayNo: 4,
    length: 1,
    meals: 'Breakfast & Lunch'
  },
  {
    place: 'Yangtze River to Chengdu',
    text: "Disembarking the ship at Chongqing you will travel to the capital of the Sichuan Province, Chengdu. Your guide will show you around the People's Park, where locals relax, mingle and exercise, then enjoy a stroll through the ancient streets of the Wide and Narrow Alleys which have been renovated to their former architectural glory.",
    dayNo: 5,
    length: 2,
    meals: 'Breakfast, Lunch & Dinner'
  },
  {
    place: 'Beijing to the UK',
    text: 'Transfer to Beijing Airport for your flight back to the UK via Shanghai',
    dayNo: 6,
    length: 1,
    meals: 'Breakfast, Lunch & Dinner'
  }
];

export const MOCK_TOUR_AVAILABILITY: TourAvailabilityResult = {
  variation: {
    id: 40,
    title: 'Impressions of Vietnam',
    path: 'south-east-asia/vietnam/impressions-of-vietnam'
  },
  results: {
    '2020': [
      {
        hotel: {
          name: 'Bella Vista Hotel',
          rating: 3.5,
          gallery: [
            '//images.ctfassets.net/3vgdkcmqrnp2/primera-hotel-hotel-exterior-id/dc8c30bcd55979cdb761e90a9fb39911/primera-hotel-hotel-exterior.jpg',
            '//images.ctfassets.net/3vgdkcmqrnp2/primera-hotel-sun-terrace-id/d1730c434cc862051da16685fa097b68/primera-hotel-sun-terrace.jpg',
            '//images.ctfassets.net/3vgdkcmqrnp2/bella-vista-hotel-facade-id/48cc49730c3500b95d5312a678d8d576/bella-vista-hotel-facade.jpg'
          ],
          nights: 4,
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
        },
        months: {
          Jun: [
            {
              departureDate: '2020-06-08T00:00:00.000Z',
              returnDate: '2020-06-15T00:00:00.000Z',
              price: { amount: 109000, currency: { code: 'GBP', symbol: '£' } },
              deepLink:
                'https://www.mercuryholidays.co.uk/search/escorted-tours?mtid=11|63&from=LHR&departureDate=2020-11-05&occ=2,0,0:0,0,0|0,0,0:0,0,0|0,0,0:0,0,0&src=ETM',
              seatsRemaining: 10,
              callToBook: true,
              soldOut: false,
              airports: [
                {
                  name: 'London Gatwick',
                  code: 'LGW'
                },
                {
                  name: 'Heathrow',
                  code: 'LHR'
                }
              ],
              alternativeItinerary: false
            },
            {
              departureDate: '2020-06-10T00:00:00.000Z',
              returnDate: '2020-06-20T00:00:00.000Z',
              price: { amount: 125000, currency: { code: 'GBP', symbol: '£' } },
              deepLink:
                'https://www.mercuryholidays.co.uk/search/escorted-tours?mtid=11|63&from=LHR&departureDate=2020-11-05&occ=2,0,0:0,0,0|0,0,0:0,0,0|0,0,0:0,0,0&src=ETM',
              seatsRemaining: 10,
              callToBook: false,
              soldOut: false,
              airports: [
                {
                  name: 'London Gatwick',
                  code: 'LGW'
                },
                {
                  name: 'Heathrow',
                  code: 'LHR'
                }
              ],
              alternativeItinerary: false
            },
            {
              departureDate: '2020-06-20T00:00:00.000Z',
              returnDate: '2020-06-27T00:00:00.000Z',
              price: { amount: 145000, currency: { code: 'GBP', symbol: '£' } },
              deepLink:
                'https://www.mercuryholidays.co.uk/search/escorted-tours?mtid=11|63&from=LHR&departureDate=2020-11-05&occ=2,0,0:0,0,0|0,0,0:0,0,0|0,0,0:0,0,0&src=ETM',
              seatsRemaining: 4,
              callToBook: false,
              soldOut: true,
              airports: [
                {
                  name: 'London Gatwick',
                  code: 'LGW'
                }
              ],
              alternativeItinerary: false
            }
          ],
          Jul: [
            {
              departureDate: '2020-07-12T00:00:00.000Z',
              returnDate: '2020-07-22T00:00:00.000Z',
              price: { amount: 225000, currency: { code: 'GBP', symbol: '£' } },
              deepLink:
                'https://www.mercuryholidays.co.uk/search/escorted-tours?mtid=11|63&from=LHR&departureDate=2020-11-05&occ=2,0,0:0,0,0|0,0,0:0,0,0|0,0,0:0,0,0&src=ETM',
              seatsRemaining: 6,
              callToBook: false,
              soldOut: true,
              airports: [
                {
                  name: 'London Gatwick',
                  code: 'LGW'
                }
              ],
              alternativeItinerary: false
            }
          ]
        }
      },
      {
        hotel: {
          name: 'Awsome Hotel',
          rating: 4.5,
          gallery: [
            '//images.ctfassets.net/3vgdkcmqrnp2/primera-hotel-hotel-exterior-id/dc8c30bcd55979cdb761e90a9fb39911/primera-hotel-hotel-exterior.jpg',
            '//images.ctfassets.net/3vgdkcmqrnp2/primera-hotel-sun-terrace-id/d1730c434cc862051da16685fa097b68/primera-hotel-sun-terrace.jpg',
            '//images.ctfassets.net/3vgdkcmqrnp2/bella-vista-hotel-facade-id/48cc49730c3500b95d5312a678d8d576/bella-vista-hotel-facade.jpg'
          ],
          nights: 4,
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
        },
        months: {
          Jun: [
            {
              departureDate: '2020-06-01T00:00:00.000Z',
              returnDate: '2020-06-16T00:00:00.000Z',
              price: { amount: 129000, currency: { code: 'GBP', symbol: '£' } },
              deepLink:
                'https://www.mercuryholidays.co.uk/search/escorted-tours?mtid=11|63&from=LHR&departureDate=2020-11-05&occ=2,0,0:0,0,0|0,0,0:0,0,0|0,0,0:0,0,0&src=ETM',
              seatsRemaining: 8,
              callToBook: false,
              soldOut: false,
              airports: [
                {
                  name: 'London Gatwick',
                  code: 'LGW'
                },
                {
                  name: 'Heathrow',
                  code: 'LHR'
                }
              ],
              alternativeItinerary: false
            },
            {
              departureDate: '2020-06-10T00:00:00.000Z',
              returnDate: '2020-06-20T00:00:00.000Z',
              price: { amount: 125000, currency: { code: 'GBP', symbol: '£' } },
              deepLink:
                'https://www.mercuryholidays.co.uk/search/escorted-tours?mtid=11|63&from=LHR&departureDate=2020-11-05&occ=2,0,0:0,0,0|0,0,0:0,0,0|0,0,0:0,0,0&src=ETM',
              seatsRemaining: 10,
              callToBook: false,
              soldOut: false,
              airports: [
                {
                  name: 'London Gatwick',
                  code: 'LGW'
                },
                {
                  name: 'Heathrow',
                  code: 'LHR'
                }
              ],
              alternativeItinerary: false
            },
            {
              departureDate: '2020-06-20T00:00:00.000Z',
              returnDate: '2020-06-27T00:00:00.000Z',
              price: { amount: 145000, currency: { code: 'GBP', symbol: '£' } },
              deepLink:
                'https://www.mercuryholidays.co.uk/search/escorted-tours?mtid=11|63&from=LHR&departureDate=2020-11-05&occ=2,0,0:0,0,0|0,0,0:0,0,0|0,0,0:0,0,0&src=ETM',
              seatsRemaining: 4,
              callToBook: false,
              soldOut: true,
              airports: [
                {
                  name: 'London Gatwick',
                  code: 'LGW'
                }
              ],
              alternativeItinerary: false
            }
          ],
          Jul: [
            {
              departureDate: '2020-07-12T00:00:00.000Z',
              returnDate: '2020-07-22T00:00:00.000Z',
              price: { amount: 225000, currency: { code: 'GBP', symbol: '£' } },
              deepLink:
                'https://www.mercuryholidays.co.uk/search/escorted-tours?mtid=11|63&from=LHR&departureDate=2020-11-05&occ=2,0,0:0,0,0|0,0,0:0,0,0|0,0,0:0,0,0&src=ETM',
              seatsRemaining: 6,
              callToBook: false,
              soldOut: true,
              airports: [
                {
                  name: 'London Gatwick',
                  code: 'LGW'
                }
              ],
              alternativeItinerary: false
            }
          ]
        }
      }
    ],
    '2021': [
      {
        hotel: {
          name: 'Bella Vista Hotel',
          rating: 3.5,
          gallery: [
            '//images.ctfassets.net/3vgdkcmqrnp2/primera-hotel-hotel-exterior-id/dc8c30bcd55979cdb761e90a9fb39911/primera-hotel-hotel-exterior.jpg',
            '//images.ctfassets.net/3vgdkcmqrnp2/primera-hotel-sun-terrace-id/d1730c434cc862051da16685fa097b68/primera-hotel-sun-terrace.jpg',
            '//images.ctfassets.net/3vgdkcmqrnp2/bella-vista-hotel-facade-id/48cc49730c3500b95d5312a678d8d576/bella-vista-hotel-facade.jpg'
          ],
          nights: 4,
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
        },
        months: {
          Mar: [
            {
              departureDate: '2021-03-01T00:00:00.000Z',
              returnDate: '2021-03-12T00:00:00.000Z',
              price: { amount: 103950, currency: { code: 'GBP', symbol: '£' } },
              deepLink:
                'https://www.mercuryholidays.co.uk/search/escorted-tours?mtid=11|63&from=LHR&departureDate=2020-11-05&occ=2,0,0:0,0,0|0,0,0:0,0,0|0,0,0:0,0,0&src=ETM',
              seatsRemaining: 2,
              callToBook: false,
              soldOut: true,
              airports: [
                {
                  name: 'London Gatwick',
                  code: 'LGW'
                }
              ],
              alternativeItinerary: false
            },
            {
              departureDate: '2021-03-15T00:00:00.000Z',
              returnDate: '2021-03-26T00:00:00.000Z',
              price: { amount: 0, currency: { code: 'GBP', symbol: '£' } },
              deepLink:
                'https://www.mercuryholidays.co.uk/search/escorted-tours?mtid=11|63&from=LHR&departureDate=2020-11-05&occ=2,0,0:0,0,0|0,0,0:0,0,0|0,0,0:0,0,0&src=ETM',
              seatsRemaining: 2,
              callToBook: true,
              soldOut: false,
              airports: [
                {
                  name: 'London Gatwick',
                  code: 'LGW'
                }
              ],
              alternativeItinerary: false
            }
          ],
          Dec: [
            {
              departureDate: '2021-12-05T00:00:00.000Z',
              returnDate: '2021-12-17T00:00:00.000Z',
              price: { amount: 225000, currency: { code: 'GBP', symbol: '£' } },
              deepLink:
                'https://www.mercuryholidays.co.uk/search/escorted-tours?mtid=11|63&from=LHR&departureDate=2020-11-05&occ=2,0,0:0,0,0|0,0,0:0,0,0|0,0,0:0,0,0&src=ETM',
              seatsRemaining: 6,
              callToBook: false,
              soldOut: false,
              airports: [
                {
                  name: 'London Gatwick',
                  code: 'LGW'
                }
              ],
              alternativeItinerary: false
            }
          ]
        }
      }
    ]
  },
  filters: {
    airports: [
      {
        name: 'Heathrow',
        code: 'LHR'
      }
    ],
    adults: [1, 2]
  },
  discountedDates: { _200: ['March 2025', 'April 2025'] }
};

export const MOCK_TOUR_AVAILABILITY_HOTEL: TourAvailabilityHotel = {
  name: '',
  rating: 0,
  gallery: ['https://example.com/test1.jpg', 'https://example.com/test2.jpg'],
  nights: 7,
  description: 'A winter wonderland at the base of the lps.'
};

export const MOCK_TOUR_AVAILABILITY_MONTHS: TourAvailabilityMonths = {
  Jan: [
    {
      reference: '',
      departureDate: '',
      returnDate: '',
      price: {
        amount: 0,
        currency: {
          code: 'GBP',
          symbol: '£'
        }
      },
      callToBook: true,
      soldOut: false,
      deepLink: '',
      seatsRemaining: 0,
      airports: [
        {
          name: 'Heathrow',
          code: 'LHR'
        }
      ],
      alternativeItinerary: false
    }
  ],
  Feb: [
    {
      reference: '',
      departureDate: '',
      returnDate: '',
      price: {
        amount: 0,
        currency: {
          code: 'GBP',
          symbol: '£'
        }
      },
      callToBook: true,
      soldOut: false,
      deepLink: '',
      seatsRemaining: 0,
      airports: [
        {
          name: 'Heathrow',
          code: 'LHR'
        }
      ],
      alternativeItinerary: false
    }
  ],
  Mar: [
    {
      reference: '',
      departureDate: '',
      returnDate: '',
      price: {
        amount: 0,
        currency: {
          code: 'GBP',
          symbol: '£'
        }
      },
      callToBook: true,
      soldOut: false,
      deepLink: '',
      seatsRemaining: 0,
      airports: [
        {
          name: 'Heathrow',
          code: 'LHR'
        }
      ],
      alternativeItinerary: false
    }
  ],
  Apr: [
    {
      reference: '',
      departureDate: '',
      returnDate: '',
      price: {
        amount: 0,
        currency: {
          code: 'GBP',
          symbol: '£'
        }
      },
      callToBook: true,
      soldOut: false,
      deepLink: '',
      seatsRemaining: 0,
      airports: [
        {
          name: 'Heathrow',
          code: 'LHR'
        }
      ],
      alternativeItinerary: false
    }
  ],
  May: [
    {
      reference: '',
      departureDate: '',
      returnDate: '',
      price: {
        amount: 0,
        currency: {
          code: 'GBP',
          symbol: '£'
        }
      },
      callToBook: true,
      soldOut: false,
      deepLink: '',
      seatsRemaining: 0,
      airports: [
        {
          name: 'Heathrow',
          code: 'LHR'
        }
      ],
      alternativeItinerary: false
    }
  ],
  Jun: [
    {
      reference: '',
      departureDate: '',
      returnDate: '',
      price: {
        amount: 0,
        currency: {
          code: 'GBP',
          symbol: '£'
        }
      },
      callToBook: true,
      soldOut: false,
      deepLink: '',
      seatsRemaining: 0,
      airports: [
        {
          name: 'Heathrow',
          code: 'LHR'
        }
      ],
      alternativeItinerary: false
    }
  ],
  Jul: [
    {
      reference: '',
      departureDate: '',
      returnDate: '',
      price: {
        amount: 0,
        currency: {
          code: 'GBP',
          symbol: '£'
        }
      },
      callToBook: true,
      soldOut: false,
      deepLink: '',
      seatsRemaining: 0,
      airports: [
        {
          name: 'Heathrow',
          code: 'LHR'
        }
      ],
      alternativeItinerary: false
    }
  ],
  Aug: [
    {
      reference: '',
      departureDate: '',
      returnDate: '',
      price: {
        amount: 0,
        currency: {
          code: 'GBP',
          symbol: '£'
        }
      },
      callToBook: true,
      soldOut: false,
      deepLink: '',
      seatsRemaining: 0,
      airports: [
        {
          name: 'Heathrow',
          code: 'LHR'
        }
      ],
      alternativeItinerary: false
    }
  ],
  Sep: [
    {
      reference: '',
      departureDate: '',
      returnDate: '',
      price: {
        amount: 0,
        currency: {
          code: 'GBP',
          symbol: '£'
        }
      },
      callToBook: true,
      soldOut: false,
      deepLink: '',
      seatsRemaining: 0,
      airports: [
        {
          name: 'Heathrow',
          code: 'LHR'
        }
      ],
      alternativeItinerary: false
    }
  ],
  Oct: [
    {
      reference: '',
      departureDate: '2024-10-20',
      returnDate: '2024-10-27',
      price: {
        amount: 2500,
        currency: {
          code: 'GBP',
          symbol: '£'
        },
        discount: 200,
        original: 2700
      },
      callToBook: true,
      soldOut: false,
      deepLink: '',
      seatsRemaining: 0,
      airports: [
        {
          name: 'Heathrow',
          code: 'LHR'
        }
      ],
      alternativeItinerary: false
    }
  ],
  Nov: [
    {
      reference: '',
      departureDate: '',
      returnDate: '',
      price: {
        amount: 0,
        currency: {
          code: 'GBP',
          symbol: '£'
        }
      },
      callToBook: true,
      soldOut: false,
      deepLink: '',
      seatsRemaining: 0,
      airports: [
        {
          name: 'Heathrow',
          code: 'LHR'
        }
      ],
      alternativeItinerary: false
    }
  ],
  Dec: [
    {
      reference: '',
      departureDate: '',
      returnDate: '',
      price: {
        amount: 0,
        currency: {
          code: 'GBP',
          symbol: '£'
        }
      },
      callToBook: true,
      soldOut: false,
      deepLink: '',
      seatsRemaining: 0,
      airports: [
        {
          name: 'Heathrow',
          code: 'LHR'
        }
      ],
      alternativeItinerary: false
    }
  ]
};

export const MOCK_TOUR_AVAILABILITY_LIST: TourAvailabilityList = {
  cheapest: {
    year: 2024,
    month: 'Oct',
    price: {
      amount: 1200,
      currency: {
        code: 'GBP',
        symbol: '$'
      },
      discount: 100,
      original: 1300
    }
  },
  availability: [
    {
      variation: {
        id: 1,
        title: '',
        path: ''
      },
      results: {
        '2024': [
          {
            hotel: { ...MOCK_TOUR_AVAILABILITY_HOTEL },
            months: { ...MOCK_TOUR_AVAILABILITY_MONTHS }
          }
        ]
      },
      filters: {
        airports: [],
        adults: []
      },
      discountedDates: { _100: ['June 2025', 'September 2025'] }
    }
  ]
};

export const MOCK_ALL_TOURS_SEARCH_RESULTS: ToursPackagesResponse = {
  data: {
    searchToken: 'd5808bae-cd8e-44d4-bf5b-5629ad02d760',
    expires: '2023-02-13T17:24:04.000000Z',
    results: [
      {
        summary: {
          place: {
            continent: { path: 'south-east-asia', display: 'South East Asia' },
            country: { name: { path: 'south-east-asia/vietnam', display: 'Vietnam' }, isoCode: 'VN' },
            region: { path: '', display: '' },
            resort: { path: '', display: '' },
            tour: {
              name: {
                path: 'south-east-asia/vietnam/vietnam-and-cambodia-explorer-with-siem-reap-city-stay',
                display: 'Vietnam and Cambodia Explorer with Siem Reap City Stay'
              }
            }
          },
          startDate: '2023-05-25',
          nights: 18,
          isExtension: true,
          featuredImage: {
            title: 'Angkor Wat Sunrise',
            url: 'https://images.mercuryholidays.co.uk/tour-details/351/angkor-wat-sunrise.jpg'
          },
          gallery: [
            { title: 'Angkor Wat', url: 'https://images.mercuryholidays.co.uk/tour-details/351/angkor-wat.jpg' },
            { title: 'Stilt Houses', url: 'https://images.mercuryholidays.co.uk/tour-details/351/stilt-houses.jpg' }
          ],
          description: 'description',
          subTitle: 'subTitle'
        },
        information: {
          excursions: 3,
          meals: 27,
          pace: 2
        },
        leadInPrice: {
          references: ['17269'],
          date: '2023-05-25T00:00:00.000000Z',
          adults: 2,
          children: 0,
          perPerson: { amount: 248800, currency: { code: 'GBP', symbol: '\u00a3' } },
          total: { amount: 497600, currency: { code: 'GBP', symbol: '\u00a3' } },
          airport: 'LHR'
        },
        popularity: 999
      },
      {
        summary: {
          place: {
            continent: { path: 'south-east-asia', display: 'South East Asia' },
            country: { name: { path: 'south-east-asia/vietnam', display: 'Vietnam' }, isoCode: 'VN' },
            region: { path: '', display: '' },
            resort: { path: '', display: '' },
            tour: {
              name: { path: 'south-east-asia/vietnam/impressions-of-vietnam', display: 'Impressions of Vietnam' }
            }
          },
          startDate: '2023-05-30',
          nights: 8,
          isExtension: false,
          featuredImage: {
            title: 'Halong Bay',
            url: 'https://images.mercuryholidays.co.uk/tour-details/1/halong-bay.jpg'
          },
          gallery: [
            {
              title: 'Flower Market, Saigon',
              url: 'https://images.mercuryholidays.co.uk/tour-details/1/flower-market%2C-saigon.jpg'
            },
            { title: 'The Huc Bridge', url: 'https://images.mercuryholidays.co.uk/tour-details/1/the-huc-bridge.jpg' },
            {
              title: 'Cu Chi Rubber Forest',
              url: 'https://images.mercuryholidays.co.uk/tour-details/1/cu-chi-rubber-forest.jpg'
            },
            { title: 'Tower Hanoi', url: 'https://images.mercuryholidays.co.uk/tour-details/1/tower-hanoi.jpg' },
            {
              title: 'Temple Of Literature',
              url: 'https://images.mercuryholidays.co.uk/tour-details/1/temple-of-literature.jpg'
            },
            { title: 'Opera House', url: 'https://images.mercuryholidays.co.uk/tour-details/1/opera-house.jpg' },
            {
              title: 'Independent Palace',
              url: 'https://images.mercuryholidays.co.uk/tour-details/1/independent-palace.jpg'
            },
            { title: 'Halong', url: 'https://images.mercuryholidays.co.uk/tour-details/1/halong.jpg' },
            {
              title: 'Halong Bay at Sunrise',
              url: 'https://images.mercuryholidays.co.uk/tour-details/1/halong-bay-at-sunrise.jpg'
            },
            {
              title: 'Inside the Post Office',
              url: 'https://images.mercuryholidays.co.uk/tour-details/1/inside-the-post-office.jpg'
            },
            { title: 'Mekong Delta', url: 'https://images.mercuryholidays.co.uk/tour-details/1/mekong-delta.jpg' },
            {
              title: 'Floating Market in Can Tho',
              url: 'https://images.mercuryholidays.co.uk/tour-details/1/floating-market-in-can-tho.jpg'
            },
            {
              title: 'Life on River in Can Tho',
              url: 'https://images.mercuryholidays.co.uk/tour-details/1/life-on-river-in-can-tho.jpg'
            }
          ],
          description: 'description',
          subTitle: 'subTitle'
        },
        information: {
          excursions: 3,
          meals: 16,
          pace: 2
        },
        leadInPrice: {
          references: ['8533'],
          date: '2023-05-30T00:00:00.000000Z',
          adults: 2,
          children: 0,
          perPerson: { amount: 168900, currency: { code: 'GBP', symbol: '\u00a3' } },
          total: { amount: 337800, currency: { code: 'GBP', symbol: '\u00a3' } },
          airport: 'LHR'
        },
        popularity: 999
      },
      {
        summary: {
          place: {
            continent: { path: 'south-east-asia', display: 'South East Asia' },
            country: { name: { path: 'south-east-asia/vietnam', display: 'Vietnam' }, isoCode: 'VN' },
            region: { path: '', display: '' },
            resort: { path: '', display: '' },
            tour: {
              name: {
                path: 'south-east-asia/vietnam/impressions-of-vietnam-with-temples-of-cambodia-extension',
                display: 'Impressions of Vietnam with Temples of Cambodia Extension'
              }
            }
          },
          startDate: '2023-05-30',
          nights: 13,
          isExtension: true,
          featuredImage: {
            title: 'View of Temples from Lake',
            url: 'https://images.mercuryholidays.co.uk/tour-details/10/view-of-temples-from-lake.jpg'
          },
          gallery: [
            {
              title: 'Temple Carvings',
              url: 'https://images.mercuryholidays.co.uk/tour-details/10/temple-carvings.jpg'
            },
            { title: 'Tonle Sap Lake', url: 'https://images.mercuryholidays.co.uk/tour-details/10/tonle-sap-lake.jpg' },
            { title: 'Angkor Thom', url: 'https://images.mercuryholidays.co.uk/tour-details/10/angkor-thom.jpg' },
            {
              title: 'Angkor Wat Entrance',
              url: 'https://images.mercuryholidays.co.uk/tour-details/10/angkor-wat-entrance.jpg'
            },
            { title: 'Temple Walkway', url: 'https://images.mercuryholidays.co.uk/tour-details/10/temple-walkway.jpg' },
            { title: 'Monkey', url: 'https://images.mercuryholidays.co.uk/tour-details/10/monkey.jpg' },
            {
              title: 'Angkor Wat Temple',
              url: 'https://images.mercuryholidays.co.uk/tour-details/10/angkor-wat-temple.jpg'
            }
          ],
          description: 'description',
          subTitle: 'subTitle'
        },
        information: {
          excursions: 0,
          meals: 39,
          pace: 3
        },
        leadInPrice: {
          references: ['8775'],
          date: '2023-05-30T00:00:00.000000Z',
          adults: 2,
          children: 0,
          perPerson: { amount: 235800, currency: { code: 'GBP', symbol: '\u00a3' } },
          total: { amount: 471600, currency: { code: 'GBP', symbol: '\u00a3' } },
          airport: 'LHR'
        },
        popularity: 999
      },
      {
        summary: {
          place: {
            continent: { path: 'south-east-asia', display: 'South East Asia' },
            country: { name: { path: 'south-east-asia/vietnam', display: 'Vietnam' }, isoCode: 'VN' },
            region: { path: '', display: '' },
            resort: { path: '', display: '' },
            tour: {
              name: {
                path: 'south-east-asia/vietnam/vietnam-and-cambodia-odyssey',
                display: 'Vietnam and Cambodia Odyssey'
              }
            }
          },
          startDate: '2023-05-18',
          nights: 20,
          isExtension: false,
          featuredImage: {
            title: 'Vietnam By Rail',
            url: 'https://images.mercuryholidays.co.uk/tour-details/124/vietnam-by-rail.jpg'
          },
          gallery: [
            {
              title: 'Halong Bay Vietnam',
              url: 'https://images.mercuryholidays.co.uk/tour-details/124/halong-bay-vietnam.jpg'
            },
            { title: 'Angkor Wat', url: 'https://images.mercuryholidays.co.uk/tour-details/124/angkor-wat.jpg' },
            {
              title: 'Angkor Thom West Gate',
              url: 'https://images.mercuryholidays.co.uk/tour-details/124/angkor-thom-west-gate.jpg'
            },
            {
              title: 'Bicycle In Saigon',
              url: 'https://images.mercuryholidays.co.uk/tour-details/124/bicycle-in-saigon.jpg'
            },
            {
              title: 'Fishing Boats Nha Trang',
              url: 'https://images.mercuryholidays.co.uk/tour-details/124/fishing-boats-nha-trang.jpg'
            },
            {
              title: 'Carved Heads At Angkor Thom',
              url: 'https://images.mercuryholidays.co.uk/tour-details/124/carved-heads-at-angkor-thom.jpg'
            },
            { title: 'Stilt Houses', url: 'https://images.mercuryholidays.co.uk/tour-details/124/stilt-houses.jpg' },
            {
              title: 'Saigon Skyline At Night',
              url: 'https://images.mercuryholidays.co.uk/tour-details/124/saigon-skyline-at-night.jpg'
            },
            {
              title: 'Ta Prohm Temple Angkor',
              url: 'https://images.mercuryholidays.co.uk/tour-details/124/ta-prohm-temple-angkor.jpg'
            },
            {
              title: 'Old Cham Towers In Nha Trang',
              url: 'https://images.mercuryholidays.co.uk/tour-details/124/old-cham-towers-in-nha-trang.jpg'
            },
            {
              title: 'Thien Mu Pagoda Hue',
              url: 'https://images.mercuryholidays.co.uk/tour-details/124/thien-mu-pagoda-hue.jpg'
            },
            {
              title: 'Thommanon Temple In Angkor',
              url: 'https://images.mercuryholidays.co.uk/tour-details/124/thommanon-temple-in-angkor.jpg'
            },
            {
              title: 'Commemorative Stupa At The Killing Fields',
              url: 'https://images.mercuryholidays.co.uk/tour-details/124/commemorative-stupa-at-the-killing-fields.jpg'
            },
            {
              title: 'Traditional Boats Hoi An',
              url: 'https://images.mercuryholidays.co.uk/tour-details/124/traditional-boats-hoi-an.jpg'
            },
            {
              title: 'Notre Dame Cathedral Saigon',
              url: 'https://images.mercuryholidays.co.uk/tour-details/124/notre-dame-cathedral-saigon.jpg'
            },
            {
              title: 'One Pillar Pagoda',
              url: 'https://images.mercuryholidays.co.uk/tour-details/124/one-pillar-pagoda.jpg'
            },
            {
              title: 'Presidential Palace Hanoi',
              url: 'https://images.mercuryholidays.co.uk/tour-details/124/presidential-palace-hanoi.jpg'
            },
            {
              title: 'Reunification Palace Ho Chi Minh City',
              url: 'https://images.mercuryholidays.co.uk/tour-details/124/reunification-palace-ho-chi-minh-city.jpg'
            },
            {
              title: 'Royal Palace In Phnom Penh',
              url: 'https://images.mercuryholidays.co.uk/tour-details/124/royal-palace-in-phnom-penh.jpg'
            },
            {
              title: 'Silver Pagoda Phnom Penh',
              url: 'https://images.mercuryholidays.co.uk/tour-details/124/silver-pagoda-phnom-penh.jpg'
            },
            {
              title: 'Waterpuppet Show',
              url: 'https://images.mercuryholidays.co.uk/tour-details/124/waterpuppet-show.jpg'
            }
          ],
          description: 'description',
          subTitle: 'subTitle'
        },
        information: {
          excursions: 5,
          meals: 0,
          pace: 0
        },
        leadInPrice: {
          references: ['14268'],
          date: '2023-05-18T00:00:00.000000Z',
          adults: 2,
          children: 0,
          perPerson: { amount: 328900, currency: { code: 'GBP', symbol: '\u00a3' } },
          total: { amount: 657800, currency: { code: 'GBP', symbol: '\u00a3' } },
          airport: 'LHR'
        },
        popularity: 999
      },
      {
        summary: {
          place: {
            continent: { path: 'south-east-asia', display: 'South East Asia' },
            country: { name: { path: 'south-east-asia/vietnam', display: 'Vietnam' }, isoCode: 'VN' },
            region: { path: '', display: '' },
            resort: { path: '', display: '' },
            tour: {
              name: {
                path: 'south-east-asia/vietnam/vietnam-and-cambodia-odyssey-with-siem-reap-city-stay',
                display: 'Vietnam and Cambodia Odyssey with Siem Reap City Stay'
              }
            }
          },
          startDate: '2023-05-11',
          nights: 22,
          isExtension: true,
          featuredImage: {
            title: 'Angkor Wat Sunrise',
            url: 'https://images.mercuryholidays.co.uk/tour-details/134/angkor-wat-sunrise.jpg'
          },
          gallery: [
            { title: 'Angkor Wat', url: 'https://images.mercuryholidays.co.uk/tour-details/134/angkor-wat.jpg' },
            { title: 'Stilt Houses', url: 'https://images.mercuryholidays.co.uk/tour-details/134/stilt-houses.jpg' }
          ],
          description: 'description',
          subTitle: 'subTitle'
        },
        information: {
          excursions: 18,
          meals: 44,
          pace: 1
        },
        leadInPrice: {
          references: ['16943'],
          date: '2023-05-11T00:00:00.000000Z',
          adults: 2,
          children: 0,
          perPerson: { amount: 341800, currency: { code: 'GBP', symbol: '\u00a3' } },
          total: { amount: 683600, currency: { code: 'GBP', symbol: '\u00a3' } },
          airport: 'LHR'
        },
        popularity: 999
      },
      {
        summary: {
          place: {
            continent: { path: 'south-east-asia', display: 'South East Asia' },
            country: { name: { path: 'south-east-asia/vietnam', display: 'Vietnam' }, isoCode: 'VN' },
            region: { path: '', display: '' },
            resort: { path: '', display: '' },
            tour: {
              name: {
                path: 'south-east-asia/vietnam/vietnam-and-cambodia-odyssey-with-laos-adventure-extension',
                display: 'Vietnam and Cambodia Odyssey with Laos Adventure Extension'
              }
            }
          },
          startDate: '2023-05-11',
          nights: 26,
          isExtension: true,
          featuredImage: {
            title: 'Patuxai In Vientiane',
            url: 'https://images.mercuryholidays.co.uk/tour-details/133/patuxai-in-vientiane.jpg'
          },
          gallery: [
            {
              title: 'Kuang Si Waterfall Luang Prabang',
              url: 'https://images.mercuryholidays.co.uk/tour-details/133/kuang-si-waterfall-luang-prabang.jpg'
            },
            {
              title: 'Buddha Park In Vientiane',
              url: 'https://images.mercuryholidays.co.uk/tour-details/133/buddha-park-in-vientiane.jpg'
            },
            {
              title: 'Tad Sae Waterfalls Luang Prabang',
              url: 'https://images.mercuryholidays.co.uk/tour-details/133/tad-sae-waterfalls-luang-prabang.jpg'
            },
            {
              title: 'Temple In Luang Prabang',
              url: 'https://images.mercuryholidays.co.uk/tour-details/133/temple-in-luang-prabang.jpg'
            }
          ],
          description: 'description',
          subTitle: 'subTitle'
        },
        information: {
          excursions: 13,
          meals: 60,
          pace: 2
        },
        leadInPrice: {
          references: ['14503'],
          date: '2023-05-11T00:00:00.000000Z',
          adults: 2,
          children: 0,
          perPerson: { amount: 425800, currency: { code: 'GBP', symbol: '\u00a3' } },
          total: { amount: 851600, currency: { code: 'GBP', symbol: '\u00a3' } },
          airport: 'LHR'
        },
        popularity: 999
      },
      {
        summary: {
          place: {
            continent: { path: 'south-east-asia', display: 'South East Asia' },
            country: { name: { path: 'south-east-asia/vietnam', display: 'Vietnam' }, isoCode: 'VN' },
            region: { path: '', display: '' },
            resort: { path: '', display: '' },
            tour: {
              name: { path: 'south-east-asia/vietnam/walking-trails-of-vietnam', display: 'Walking Trails of Vietnam' }
            }
          },
          startDate: '2023-05-02',
          nights: 8,
          isExtension: false,
          featuredImage: {
            title: 'Mai Chau',
            url: 'https://images.mercuryholidays.co.uk/tour-details/226/mai-chau.jpg'
          },
          gallery: [
            { title: 'Hanoi', url: 'https://images.mercuryholidays.co.uk/tour-details/226/hanoi.jpg' },
            {
              title: 'Pu Luong Retreat',
              url: 'https://images.mercuryholidays.co.uk/tour-details/226/pu-luong-retreat.jpg'
            },
            {
              title: 'Hanoi   Presidential Palace',
              url: 'https://images.mercuryholidays.co.uk/tour-details/226/hanoi---presidential-palace.jpg'
            },
            {
              title: 'Hanoi   Temple Of Literature',
              url: 'https://images.mercuryholidays.co.uk/tour-details/226/hanoi---temple-of-literature.jpg'
            },
            {
              title: 'Ninh Binh   Limestone Mountains',
              url: 'https://images.mercuryholidays.co.uk/tour-details/226/ninh-binh---limestone-mountains.jpg'
            },
            { title: 'Ninh Binh', url: 'https://images.mercuryholidays.co.uk/tour-details/226/ninh-binh.jpg' },
            { title: 'Tan Lap Bridge', url: 'https://images.mercuryholidays.co.uk/tour-details/226/tan-lap-bridge.jpg' }
          ],
          description: 'description',
          subTitle: 'subTitle'
        },
        information: {
          excursions: 3,
          meals: 27,
          pace: 2
        },
        leadInPrice: {
          references: ['4913'],
          date: '2023-05-02T00:00:00.000000Z',
          adults: 2,
          children: 0,
          perPerson: { amount: 174000, currency: { code: 'GBP', symbol: '\u00a3' } },
          total: { amount: 348000, currency: { code: 'GBP', symbol: '\u00a3' } },
          airport: 'LHR'
        },
        popularity: 999
      },
      {
        summary: {
          place: {
            continent: { path: 'south-east-asia', display: 'South East Asia' },
            country: { name: { path: 'south-east-asia/vietnam', display: 'Vietnam' }, isoCode: 'VN' },
            region: { path: '', display: '' },
            resort: { path: '', display: '' },
            tour: { name: { path: 'south-east-asia/vietnam/splendours-of-vietnam', display: 'Splendours of Vietnam' } }
          },
          startDate: '2023-05-13',
          nights: 15,
          isExtension: false,
          featuredImage: {
            title: 'Halong Bay',
            url: 'https://images.mercuryholidays.co.uk/tour-details/282/halong-bay.jpg'
          },
          gallery: [
            {
              title: 'Old Fisherman Boat With Anchor',
              url: 'https://images.mercuryholidays.co.uk/tour-details/282/old-fisherman-boat-with-anchor.jpg'
            },
            {
              title: 'Vietnamese Bike',
              url: 'https://images.mercuryholidays.co.uk/tour-details/282/vietnamese-bike.jpg'
            },
            {
              title: 'Cham Towers In Nha Trang',
              url: 'https://images.mercuryholidays.co.uk/tour-details/282/cham-towers-in-nha-trang.jpg'
            },
            {
              title: 'View Of Halong Bay',
              url: 'https://images.mercuryholidays.co.uk/tour-details/282/view-of-halong-bay.jpg'
            },
            {
              title: 'Vietnamese Conical Hat',
              url: 'https://images.mercuryholidays.co.uk/tour-details/282/vietnamese-conical-hat.jpg'
            },
            { title: 'Hue', url: 'https://images.mercuryholidays.co.uk/tour-details/282/hue.jpg' },
            { title: 'North Vietnam', url: 'https://images.mercuryholidays.co.uk/tour-details/282/north-vietnam.jpg' },
            {
              title: 'Bun Bo Hue Soup',
              url: 'https://images.mercuryholidays.co.uk/tour-details/282/bun-bo-hue-soup.jpg'
            },
            {
              title: 'Vietnam Culture',
              url: 'https://images.mercuryholidays.co.uk/tour-details/282/vietnam-culture.jpg'
            }
          ],
          description: 'description',
          subTitle: 'subTitle'
        },
        information: {
          excursions: 3,
          meals: 27,
          pace: 2
        },
        leadInPrice: {
          references: ['14782'],
          date: '2023-05-13T00:00:00.000000Z',
          adults: 2,
          children: 0,
          perPerson: { amount: 223900, currency: { code: 'GBP', symbol: '\u00a3' } },
          total: { amount: 447800, currency: { code: 'GBP', symbol: '\u00a3' } },
          airport: 'LHR'
        },
        popularity: 999
      },
      {
        summary: {
          place: {
            continent: { path: 'south-east-asia', display: 'South East Asia' },
            country: { name: { path: 'south-east-asia/vietnam', display: 'Vietnam' }, isoCode: 'VN' },
            region: { path: '', display: '' },
            resort: { path: '', display: '' },
            tour: {
              name: {
                path: 'south-east-asia/vietnam/splendours-of-vietnam-with-temples-of-cambodia-extension',
                display: 'Splendours of Vietnam with Temples of Cambodia Extension'
              }
            }
          },
          startDate: '2023-05-13',
          nights: 18,
          isExtension: true,
          featuredImage: {
            title: 'View of Temples from Lake',
            url: 'https://images.mercuryholidays.co.uk/tour-details/287/view-of-temples-from-lake.jpg'
          },
          gallery: [
            {
              title: 'Temple Carvings',
              url: 'https://images.mercuryholidays.co.uk/tour-details/287/temple-carvings.jpg'
            },
            {
              title: 'Tonle Sap Lake',
              url: 'https://images.mercuryholidays.co.uk/tour-details/287/tonle-sap-lake.jpg'
            },
            { title: 'Angkor Thom', url: 'https://images.mercuryholidays.co.uk/tour-details/287/angkor-thom.jpg' },
            {
              title: 'Angkor Wat Entrance',
              url: 'https://images.mercuryholidays.co.uk/tour-details/287/angkor-wat-entrance.jpg'
            },
            {
              title: 'Temple Walkway',
              url: 'https://images.mercuryholidays.co.uk/tour-details/287/temple-walkway.jpg'
            },
            { title: 'Monkey', url: 'https://images.mercuryholidays.co.uk/tour-details/287/monkey.jpg' },
            {
              title: 'Angkor Wat Temple',
              url: 'https://images.mercuryholidays.co.uk/tour-details/287/angkor-wat-temple.jpg'
            }
          ],
          description: 'description',
          subTitle: 'subTitle'
        },
        information: {
          excursions: 3,
          meals: 27,
          pace: 2
        },
        leadInPrice: {
          references: ['14876'],
          date: '2023-05-13T00:00:00.000000Z',
          adults: 2,
          children: 0,
          perPerson: { amount: 286800, currency: { code: 'GBP', symbol: '\u00a3' } },
          total: { amount: 573600, currency: { code: 'GBP', symbol: '\u00a3' } },
          airport: 'LHR'
        },
        popularity: 999
      },
      {
        summary: {
          place: {
            continent: { path: 'south-east-asia', display: 'South East Asia' },
            country: { name: { path: 'south-east-asia/vietnam', display: 'Vietnam' }, isoCode: 'VN' },
            region: { path: '', display: '' },
            resort: { path: '', display: '' },
            tour: {
              name: {
                path: 'south-east-asia/vietnam/vietnam-and-cambodia-explorer',
                display: 'Vietnam and Cambodia Explorer'
              }
            }
          },
          startDate: '2023-05-25',
          nights: 15,
          isExtension: false,
          featuredImage: {
            title: 'Angkor Thom Entrance',
            url: 'https://images.mercuryholidays.co.uk/tour-details/342/angkor-thom-entrance.jpg'
          },
          gallery: [
            { title: 'Angkor Wat', url: 'https://images.mercuryholidays.co.uk/tour-details/342/angkor-wat.jpg' },
            {
              title: 'Cai Rang Floating Market',
              url: 'https://images.mercuryholidays.co.uk/tour-details/342/cai-rang-floating-market.jpg'
            },
            { title: 'Ha Long Bay', url: 'https://images.mercuryholidays.co.uk/tour-details/342/ha-long-bay.jpg' },
            { title: 'Hanoi', url: 'https://images.mercuryholidays.co.uk/tour-details/342/hanoi.jpg' },
            {
              title: 'Ho Chi Minh City Skyline',
              url: 'https://images.mercuryholidays.co.uk/tour-details/342/ho-chi-minh-city-skyline.jpg'
            },
            {
              title: 'Japanese Pagoda Bridge',
              url: 'https://images.mercuryholidays.co.uk/tour-details/342/japanese-pagoda-bridge.jpg'
            },
            { title: 'Mekong Cruise', url: 'https://images.mercuryholidays.co.uk/tour-details/342/mekong-cruise.jpg' },
            { title: 'Royal Palace', url: 'https://images.mercuryholidays.co.uk/tour-details/342/royal-palace.jpg' },
            { title: 'Ta Prohm', url: 'https://images.mercuryholidays.co.uk/tour-details/342/ta-prohm.jpg' },
            {
              title: 'Toul Sleng Prison Museum',
              url: 'https://images.mercuryholidays.co.uk/tour-details/342/toul-sleng-prison-museum.jpg'
            }
          ],
          description: 'description',
          subTitle: 'subTitle'
        },
        information: {
          excursions: 3,
          meals: 27,
          pace: 2
        },
        leadInPrice: {
          references: ['17055'],
          date: '2023-05-25T00:00:00.000000Z',
          adults: 2,
          children: 0,
          perPerson: { amount: 228900, currency: { code: 'GBP', symbol: '\u00a3' } },
          total: { amount: 457800, currency: { code: 'GBP', symbol: '\u00a3' } },
          airport: 'LHR'
        },
        popularity: 999
      },
      {
        summary: {
          place: {
            continent: { path: 'south-east-asia', display: 'South East Asia' },
            country: { name: { path: 'south-east-asia/vietnam', display: 'Vietnam' }, isoCode: 'VN' },
            region: { path: '', display: '' },
            resort: { path: '', display: '' },
            tour: {
              name: {
                path: 'south-east-asia/vietnam/vietnam-and-cambodia-explorer-with-mui-ne-beach-stay',
                display: 'Vietnam and Cambodia Explorer with Mui Ne Beach Stay'
              }
            }
          },
          startDate: '2023-05-25',
          nights: 19,
          isExtension: true,
          featuredImage: {
            title: 'Mui Ne Beach',
            url: 'https://images.mercuryholidays.co.uk/tour-details/352/mui-ne-beach.jpg'
          },
          gallery: [
            { title: 'Mui Ne Sunset', url: 'https://images.mercuryholidays.co.uk/tour-details/352/mui-ne-sunset.jpg' }
          ],
          description: 'description',
          subTitle: 'subTitle'
        },
        information: {
          excursions: 3,
          meals: 27,
          pace: 2
        },
        leadInPrice: {
          references: ['17183'],
          date: '2023-05-25T00:00:00.000000Z',
          adults: 2,
          children: 0,
          perPerson: { amount: 270800, currency: { code: 'GBP', symbol: '\u00a3' } },
          total: { amount: 541600, currency: { code: 'GBP', symbol: '\u00a3' } },
          airport: 'LHR'
        },
        popularity: 999
      }
    ],
    facets: {
      filters: [
        {
          name: 'profile',
          type: 'sort',
          formattedName: 'Sort By',
          values: [
            { name: 'Popularity: High to Low', value: '1', selected: true, count: 0 },
            { name: 'Popularity: Low to High', value: '2', selected: false, count: 0 },
            { name: 'Price: High to Low', value: '3', selected: false, count: 0 },
            { name: 'Price: Low to High', value: '4', selected: false, count: 0 }
          ]
        },
        {
          name: 'countries',
          type: 'checkbox',
          formattedName: 'Country',
          values: [
            { name: 'Vietnam', value: '75', selected: false, count: 11 },
            { name: 'Cambodia', value: '70', selected: false, count: 3 }
          ]
        },
        {
          name: 'tours',
          type: 'checkbox',
          formattedName: 'Tour',
          values: [
            { name: 'Vietnam and Cambodia Explorer with Siem Reap City Stay', value: '784', selected: false, count: 1 },
            { name: 'Impressions of Vietnam', value: '1', selected: false, count: 1 },
            {
              name: 'Impressions of Vietnam with Temples of Cambodia Extension',
              value: '2',
              selected: false,
              count: 1
            },
            { name: 'Vietnam and Cambodia Odyssey', value: '273', selected: false, count: 1 },
            { name: 'Vietnam and Cambodia Odyssey with Siem Reap City Stay', value: '771', selected: false, count: 1 },
            {
              name: 'Vietnam and Cambodia Odyssey with Laos Adventure Extension',
              value: '275',
              selected: false,
              count: 1
            },
            { name: 'Walking Trails of Vietnam', value: '448', selected: false, count: 1 },
            { name: 'Splendours of Vietnam', value: '579', selected: false, count: 1 },
            {
              name: 'Splendours of Vietnam with Temples of Cambodia Extension',
              value: '580',
              selected: false,
              count: 1
            },
            { name: 'Vietnam and Cambodia Explorer', value: '722', selected: false, count: 1 },
            { name: 'Vietnam and Cambodia Explorer with Mui Ne Beach Stay', value: '855', selected: false, count: 1 }
          ]
        }
      ],
      counts: { total: 14, filtered: 14 }
    },
    nextSet: 0
  }
};

export const MOCK_SINGLE_TOUR_SEARCH_RESULTS: ToursPackagesResponse = {
  data: {
    searchToken: '37a4bf98-4b02-4360-a96e-0fca83e237cc',
    expires: '2023-02-14T10:53:49.000000Z',
    results: [],
    facets: {
      filters: [
        {
          name: 'profile',
          type: 'sort',
          formattedName: 'Sort By',
          values: [
            { name: 'Popularity: High to Low', value: '1', selected: true, count: 0 },
            { name: 'Popularity: Low to High', value: '2', selected: false, count: 0 },
            { name: 'Price: High to Low', value: '3', selected: false, count: 0 },
            { name: 'Price: Low to High', value: '4', selected: false, count: 0 }
          ]
        }
      ],
      counts: { total: 0, filtered: 0 }
    },
    nextSet: 0
  }
};

export const MOCK_SINGLE_TOUR_SEARCH_NO_RESULT: ToursPackagesResponse = {
  data: {
    searchToken: '6af44b01-b535-4076-ac91-f98dfc87803a',
    expires: '2023-02-13T17:34:27.000000Z',
    results: [],
    facets: {
      filters: [
        {
          name: 'profile',
          type: 'sort',
          formattedName: 'Sort By',
          values: [
            { name: 'Popularity: High to Low', value: '1', selected: true, count: 0 },
            { name: 'Popularity: Low to High', value: '2', selected: false, count: 0 },
            { name: 'Price: High to Low', value: '3', selected: false, count: 0 },
            { name: 'Price: Low to High', value: '4', selected: false, count: 0 }
          ]
        }
      ],
      counts: { total: 0, filtered: 0 }
    },
    nextSet: 0
  }
};

export const MOCK_TOUR_HIT: TourHit = {
  name: 'Uzbekistan and the Silk Route',
  country: 'Uzbekistan',
  continent: 'Central Asia',
  definitionId: 245,
  path: 'central-asia/uzbekistan/uzbekistan-and-the-silk-route',
  countryId: 19,
  extension: false,
  type: TourType.TOUR,
  tripType: TripTypes.ESCORTED_TOURS,
  airports: [{ code: 'LHR', name: 'Heathrow' }],
  objectID: '93',
  isoCode: 'UZ'
};

export const OTHER_TOUR_HIT: TourHit = {
  name: 'Carpets of Uzbekistan',
  country: 'Uzbekistan',
  continent: 'Central Asia',
  definitionId: 500,
  path: 'central-asia/uzbekistan/uzbekistan-and-the-silk-route',
  countryId: 19,
  extension: false,
  type: TourType.TOUR,
  tripType: TripTypes.ESCORTED_TOURS,
  airports: [{ code: 'LHR', name: 'Heathrow' }],
  objectID: '94',
  isoCode: 'UZ'
};

export const MOCK_TOUR_STATE: TourSearchState = { ...INITIAL_TOUR_SEARCH_STATE, privateTours: [OTHER_TOUR_HIT] };

export const MOCK_TOUR_DESTINATION: TourHit = {
  name: 'All Uzbekistan Tours',
  country: 'Uzbekistan',
  continent: 'Central Asia',
  definitionId: 0,
  path: 'central-asia/uzbekistan',
  countryId: 19,
  extension: false,
  type: TourType.DESTINATION,
  tripType: TripTypes.ALL,
  airports: [{ code: 'LHR', name: 'Heathrow' }],
  objectID: 'country_19',
  isoCode: 'UZ'
};

export const MOCK_TOUR_HOTELS: Array<TourHotel> = [
  {
    name: 'Sunway Hotel',
    description:
      'The recently renovated Sunway Hotel is well-positioned, within easy walking distance to the Opera House, Vincom Shopping Mall and Hanoi Old Quarter. The hotel has good facilities and friendly, attentive staff.',
    rating: 4,
    ratingType: RatingType.STARS,
    resort: '',
    country: 'Vietnam',
    address: '19 Pham Dinh Ho Street, Hanoi, Hai Ba Trung District',
    telephone: '+84 4 3971 3888',
    gallery: [
      {
        title: 'Superior Room',
        url: 'https://images.mercuryholidays.co.uk/tour-hotel/1509/superior-room.jpg'
      },
      {
        title: 'Restaurant',
        url: 'https://images.mercuryholidays.co.uk/tour-hotel/1509/restaurant.jpg'
      },
      {
        title: 'Bar',
        url: 'https://images.mercuryholidays.co.uk/tour-hotel/1509/bar.jpg'
      },
      {
        title: 'Lobby',
        url: 'https://images.mercuryholidays.co.uk/tour-hotel/1509/lobby.jpg'
      },
      {
        title: 'Reception',
        url: 'https://images.mercuryholidays.co.uk/tour-hotel/1509/reception.jpg'
      },
      {
        title: 'Entrance',
        url: 'https://images.mercuryholidays.co.uk/tour-hotel/1509/entrance.jpg'
      },
      {
        title: 'Club Classic Double Room',
        url: 'https://images.mercuryholidays.co.uk/tour-hotel/1509/club-classic-double-room.jpg'
      },
      {
        title: 'Deluxe King Room',
        url: 'https://images.mercuryholidays.co.uk/tour-hotel/1509/deluxe-king-room.jpg'
      }
    ],
    featuredImage: 'https://images.mercuryholidays.co.uk/tour-hotel/3571/hotel-exterior.jpg',
    deckPlans: [],
    cabinPlan: {
      title: '',
      url: ''
    },
    cabinPlanCaption: null,
    cabinInformation: null,
    departureDates: [],
    nights: 3
  },
  {
    name: 'Paragon Hotel',
    description:
      'Boasting an ideal location in Ho Chi Minh City, just a short walk from the Opera House and Vincom Shopping Centre. The property is equipped with a rooftop swimming pool, fitness centre, and on-site restaurant. Paragon Saigon offers 164 rooms. All rooms are fitted with an en-suite bathroom, free Wi-Fi, international?direct telephone, and a minibar. En-suite bathrooms come with a shower or bathtub.',
    rating: 4,
    ratingType: RatingType.STARS,
    resort: 'Hoi An',
    country: 'Vietnam',
    address: '22-24 Thi Sach, Ben Nghe, Quan 1, Thanh pho Ho Chi Minh, 70000',
    telephone: '+84 90 986 06 98',
    gallery: [
      {
        title: 'Hotel Exterior',
        url: 'https://images.mercuryholidays.co.uk/tour-hotel/11012/hotel-exterior.jpg'
      },
      {
        title: 'Twin Room',
        url: 'https://images.mercuryholidays.co.uk/tour-hotel/11012/twin-room.jpg'
      }
    ],
    featuredImage: 'https://images.mercuryholidays.co.uk/tour-hotel/3571/hotel-exterior.jpg',
    deckPlans: [],
    cabinPlan: {
      title: '',
      url: ''
    },
    cabinPlanCaption: null,
    cabinInformation: null,
    departureDates: [],
    nights: 2
  },
  {
    name: 'West Hotel Can Tho',
    description:
      'Situated an ideal location, West hotel is just 100 meters from Ninh Kieu Wharf and 300 meters from Can Tho Museum. The hotel features a range of facilities including a 24-hour front desk, an indoor swimming pool, a fitness center and an on-site restaurant and bar.  Rooms feature either river or city views, all rooms are air-conditioned and come with a wardrobe, safe, minibar and flat-screen TV. The en-suite is complete with slippers, a hairdryer and free toiletries.',
    rating: 4,
    ratingType: RatingType.STARS,
    resort: 'Hoi An',
    country: 'Vietnam',
    address: '90-92 D?ong Hai Ba Trung, Tan An, Ninh Kieu, Can Tho',
    telephone: '+84 292 3683 368',
    gallery: [
      {
        title: 'West Hotel',
        url: 'https://images.mercuryholidays.co.uk/tour-hotel/11014/west-hotel.jpg'
      },
      {
        title: 'Twin Room West Hotel',
        url: 'https://images.mercuryholidays.co.uk/tour-hotel/11014/twin-room-west-hotel.jpg'
      }
    ],
    featuredImage: 'https://images.mercuryholidays.co.uk/tour-hotel/3571/hotel-exterior.jpg',
    deckPlans: [],
    cabinPlan: {
      title: '',
      url: ''
    },
    cabinPlanCaption: null,
    cabinInformation: null,
    departureDates: [],
    nights: 1
  },
  {
    name: 'Victory Cruise Boat',
    description:
      'This traditional and elegant vessel will be your transport and accommodation for the night. Experience the food and hospitality on board as your cruise takes you through beautiful Halong Bay, past its breath-taking scenery, stopping to enjoy highlights along the way. Your private cabin offers exceptional comfort with all the amenities and facilities you would expect. Please note that departures on the 20th of May 2015 will be accommodated on a different boat of a similar standard. ',
    rating: null,
    ratingType: RatingType.STARS,
    resort: 'Halong Bay',
    country: 'Vietnam',
    address: 'Halong Bay',
    telephone: '',
    gallery: [
      {
        title: 'Victory Cruise',
        url: 'https://images.mercuryholidays.co.uk/tour-hotel/9935/victory-cruise.jpg'
      }
    ],
    featuredImage: 'https://images.mercuryholidays.co.uk/tour-hotel/3571/hotel-exterior.jpg',
    deckPlans: [],
    cabinPlan: {
      title: '',
      url: ''
    },
    cabinPlanCaption: null,
    cabinInformation: null,
    departureDates: [],
    nights: 1
  }
];

export const MOCK_TOUR_EXTRAS: Array<TourExtra> = [
  {
    token: '0f4dc49f-3452-4cf8-ab93-220ead72a73f',
    price: { amount: 93278, currency: { code: 'GBP', symbol: '£' } },
    extraId: 1897,
    name: 'Alaskan Coastal Cruise',
    notes: '',
    category: 'Category J Cabin (FB)',
    startDate: '2024-04-27T00:00:00.000000Z',
    endDate: '2024-05-04T00:00:00.000000Z',
    optionToken: 'f2556e39-2e31-4275-8189-ca097ea108a1'
  },
  {
    token: 'b83b3e41-e6eb-4cd5-90fc-1431062d1503',
    price: { amount: 83900, currency: { code: 'GBP', symbol: '£' } },
    extraId: 1899,
    name: 'Vancouver Extension (Alaskan Coastal Cruise)',
    notes: '',
    category: 'Double Room (RO)',
    startDate: '2024-05-04T00:00:00.000000Z',
    endDate: '2024-05-08T00:00:00.000000Z',
    optionToken: '60b209d8-3f71-4355-9a5f-7ebcd505eb28'
  }
];

export const MOCK_TOUR_EXTRAS_WITH_ROOMS: Array<TourExtra> = [
  {
    price: { amount: 93278, currency: { code: 'GBP', symbol: '£' } },
    extraId: 1897,
    extraName: 'Alaskan Coastal Cruise',
    notes: '',
    checkInDate: '2024-04-27T00:00:00.000000Z',
    checkOutDate: '2024-05-04T00:00:00.000000Z',
    rooms: [
      {
        roomType: 'Double Room (RO)',
        occupancy: {
          adults: 0,
          children: 0,
          infants: 0
        }
      }
    ]
  },
  {
    price: { amount: 83900, currency: { code: 'GBP', symbol: '£' } },
    extraId: 1899,
    extraName: 'Jewels of Sri Lanka',
    notes: '',
    checkInDate: '2024-05-04T00:00:00.000000Z',
    checkOutDate: '2024-05-08T00:00:00.000000Z',
    rooms: [
      {
        roomType: 'Double Room (FB)',
        occupancy: {
          adults: 0,
          children: 0,
          infants: 0
        }
      }
    ]
  }
];

export const MOCK_EXTRAS_OPTIONS: Array<ExtrasOptions> = [
  {
    extraToken: 'b83b3e41-e6eb-4cd5-90fc-1431062d1503',
    options: [
      {
        optionToken: '1f34528d-0c9f-4dfa-8b3d-39493344ab00',
        category: 'Double Room (RO)',
        notes: '',
        duration: 5,
        totalPrice: { amount: 167800, currency: { code: 'GBP', symbol: '£' } },
        perPersonPrice: { amount: 83900, currency: { code: 'GBP', symbol: '£' } }
      }
    ]
  },
  {
    extraToken: '0f4dc49f-3452-4cf8-ab93-220ead72a73f',
    options: [
      {
        optionToken: 'bba97df3-02f5-414c-8057-ad35e8a6e1d0',
        category: 'Category J Cabin (FB)',
        notes: '',
        duration: 8,
        totalPrice: { amount: 186556, currency: { code: 'GBP', symbol: '£' } },
        perPersonPrice: { amount: 93273, currency: { code: 'GBP', symbol: '£' } }
      },
      {
        optionToken: '86fd07c8-3b4e-4819-938f-15d98b16a9b0',
        category: 'Category I Cabin (FB)',
        notes: '',
        duration: 8,
        totalPrice: { amount: 196356, currency: { code: 'GBP', symbol: '£' } },
        perPersonPrice: { amount: 93273, currency: { code: 'GBP', symbol: '£' } }
      },
      {
        optionToken: 'bbbb088c-f59a-4894-82c7-10aa22a76344',
        category: 'Category E Cabin (FB)',
        notes: '',
        duration: 8,
        totalPrice: { amount: 272356, currency: { code: 'GBP', symbol: '£' } },
        perPersonPrice: { amount: 93273, currency: { code: 'GBP', symbol: '£' } }
      },
      {
        optionToken: '55d4a5f3-f08c-4ec3-9a70-c19c492f74c3',
        category: 'Category D Cabin (FB)',
        notes: '',
        duration: 8,
        totalPrice: { amount: 278356, currency: { code: 'GBP', symbol: '£' } },
        perPersonPrice: { amount: 93273, currency: { code: 'GBP', symbol: '£' } }
      },
      {
        optionToken: 'dae22db4-2330-46d7-8a11-5c69547c9406',
        category: 'Category VA Cabin (FB)',
        notes: '',
        duration: 8,
        totalPrice: { amount: 330356, currency: { code: 'GBP', symbol: '£' } },
        perPersonPrice: { amount: 93273, currency: { code: 'GBP', symbol: '£' } }
      }
    ]
  }
];
